import React from 'react';
import { useParams } from 'react-router-dom';
import { selectLmsLists } from '../../../store/features/lmsSlice';
import { useAppSelector } from '../../../store/hook';
import TextWinds from '../../../components/common/TextWinds';
import BoostUp from '../../../components/lms/membership-store/boostup/boostup';
import TopButton from '../../../components/common/TopButton';

/**
 * 개편 LMS (교사) - 멤버십 스토어 페이지
 */
const MembershipStore = () => {
  const classId = useParams().classId;

  const lmsLists = useAppSelector(selectLmsLists);

  return (
    <div className="flex w-full flex-col pt-6 xl:px-5">
      <header className="px-5 xl:px-0">
        <TextWinds type="title_h2" xlType="title_h3" className="mb-[2px]">
          멤버십 스토어
        </TextWinds>

        <TextWinds type="content_body3">
          코스 연장 상품 및 교재, 교구를 구매합니다. 본 코스를 수료 후 운영 기간
          중에 계신 선생님만 구매할 수 있습니다.
        </TextWinds>
      </header>

      <div className="my-5 gap-4 px-3 xl:px-0">
        <section className="flex flex-col gap-5">
          {/* 부스트업 */}
          <BoostUp classId={classId} lmsLists={lmsLists} />
        </section>
      </div>

      <TopButton />
    </div>
  );
};

export default MembershipStore;
